import React, { useState, useEffect } from "react";
import AddCircle from '@mui/icons-material/AddCircleRounded';
import SearchIcon from '@mui/icons-material/SearchTwoTone';
import { InputGroup, Button, FormControl, Modal, Col, Row } from "react-bootstrap";
import ApiUserManager from "../../../core/api/api.userManager";
import { FormProvider, useForm, Controller } from "react-hook-form";
import _ from "lodash";
import DataGrid from "./DataGrid";
import AddEditeModal from "./AddEditeModal";
import { tools } from "../../../core/utils/tools";
import { useLocation, useNavigate } from "react-router";
import GlobalFormControl from "../_Components/GlobalFormControl";


const Users = () => {
  const [listData, setListData] = useState([{}]);
  const { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const [showModalUser, setShowModalUser] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const pageSizeFromUrl1 = searchParams.get("pageSize");
  const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : 10;
  const pageNumberFromUrl1 = searchParams.get("pageNumber");
  const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1) ? _.toNumber(pageNumberFromUrl1) : 1;
  useEffect(() => {
    (async () => {
      try {
        //دریافت لیست کاربران ادمین
        const data = await ApiUserManager.getAllAdminUsers({
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
          globalSearch: searchParams.get("globalSearch"),
        });
        setListData(data);
        setValue("totalCount", data.totalCount);
        const formInputs = [
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();
    return () => { };
  }, []);

  const onSubmit =
    async (data) => {
      const apiData = await ApiUserManager.getAllAdminUsers({ pageSize: data.pageSize, pageNumber: getValues("pageNumber"), globalSearch: data.globalSearch });
      setListData(apiData);
      setValue("totalCount", apiData.totalCount);
      tools.setPageNumber(data, searchParams, setValue);
      var queryString = tools.createQueryStringFromFromData(_.omit(data, ["totalPages", "totalCount"]));
      navigate(`/users?${queryString}`);
    }

  return (
    <div>

      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              مدیریت کاربران
                        </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لیست کاربران
                        </span>
          </h3>
          <div className="card-toolbar">
            <Button
              onClick={() => {
                setSelectedUserId(0);
                setShowModalUser(true);
              }}
            >
              <AddCircle className='mr-1' />
                          افزودن کاربر
                        </Button>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods} >
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className='border-top pt-3'>
                <InputGroup className="mb-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder='جستجو ...'
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}><SearchIcon /></Button>

                </InputGroup>
              </div>
              {/* table */}
              <Col xs='12' className='tb-reponsive px-0'>
                <DataGrid data={listData} setShowModalUser={setShowModalUser} setSelectedUserId={setSelectedUserId}
                />
              </Col>
              {showModalUser && (
                <AddEditeModal
                  showModalUser={showModalUser}
                  setShowModalUser={setShowModalUser}
                  selectedUserId={selectedUserId}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
}
export default Users;